import React, { useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
// import TableComponent from "./Table";
import ProductsInfo from "./ProductsInfo";
import whatsapp from "../utils/whatsapp.png";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ItemSearchPopup from "./ItemSearchPopup";
import "../css/allEntriesForm.css";
import CustomerSearchF2Popup from "../modals/CustomerSearchF2Popup";

const AllEntriesForm = ({ onFormSubmit, toEditLead, onEditCancelLead }) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-" // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"


  const [f2CustomerSearch, setF2CustomerSearch] = useState(false)
  const [f2PopupViewToggle, setF2PopupViewToggle] = useState(false)
  const [currentF2ItemForSearchPopup, setCurrentF2ItemForSearchPopup] = useState(0)

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const userAccessGroup = currentUserObject[0].accessgrp;
  const [accessgroupFromLocal, setAccessgroupFromLocal] = useState(userAccessGroup)

  useEffect(() => {

    console.log("currentF2ItemForSearchPopup", currentF2ItemForSearchPopup)

  }, [currentF2ItemForSearchPopup])
  // const location = useLocation();

  // const toEditLead = location.state?.toEditLead;

  const currentUserName = localStorage.getItem("currentUserName");

  const [userName, setUserName] = useState(currentUserName);

  console.log("toEditLead updated in AllEntriesForm:", toEditLead);

  const currentUserfromLocalStorage = JSON.parse(
    localStorage.getItem("currentUser")
  );

  const currentDepartmentFromLocalStorage = localStorage.getItem(
    "currentSelectedDepartment"
  );

  let currentUserEMPID = "-";

  if (currentUserfromLocalStorage) {
    console.log(
      "currentUserfromLocalStorage[0] ",
      currentUserfromLocalStorage[0]
    );
    currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
  } else {
    console.log(
      "currentUserfromLocalStorage[0] else",
      currentUserfromLocalStorage[0]
    );
  }

  const [coordinatorList, setCoordinatorList] = useState(null);
  const [salespersonList, setSalesPersonList] = useState(null);

  const initialFormData = {
    id: Date.now(), // [lead_id]
    // name: "", // ,[lead_primarycontact]
    lead: "", // ,[lead_primarycontact]
    phone: "", // [lead_phone]
    alternatePhone: "", // ,[lead_alt_phone]
    isPhoneWhatsApp: false, // [lead_isphonewhatsapp]
    isAlternatePhoneWhatsApp: false, // [lead_alt_isphonewhatsapp]
    status: "", // [lead_status]
    organization: "", // ,[lead_organization]
    title: "", // ,[lead_primarycontacttitle]
    email: "", // [lead_email]
    notes: "", // [lead_notes]
    leadSource: "",
    coordinator: "", // [lead_coordinator],
    salesperson: "", // [lead_coordinator]
    assignTo: "", //[lead_assignedto]
    docs: "",
    campaignId: "", // [lead_CampaignId]
    departmentNo: "", // ,[deptno]
    // leadDateAndTimeEntry: "",==========
    probability: "", // [lead_probability]
    currency: "AED",
    bookedAmount: "", // [lead_bookedamount]
    territory: "dubai", // [lead_territory]
    country: "unitedArabEmirates", // [lead_country]
    streetAddress: "", // [lead_streetaddress]
    city: "", // [lead_city]
    apartment: "", // [lead_appartment]
    location: "", // ,[lead_location]
    area: "", // ,[lead_area]
    priority: "", // [lead_priority]
    leadEntryTime: "", // ,[lead_entryTime]
    timeline: "",
    isItemAdded: "",
    itemCode: "",
    itemDescription: "",
    itemUnit: "",
    itemCurrentStock: "",
    itemQuantity: "",
    itemPrice: "",
    itemAmount: "",
    // [lead_stage]

    // i dont have
    // ,[lead_currencycode]
    // ,[lead_currencyrate]
    // ,[lead_salesperson]
    // ,[lead_teamid]
    // ,[lead_account]

    // "CmpCode": null,
    // "mode": null,
    // "alternateEmail": null,
    //   "SalesPerson": null,
    //   "TeamID": null,
    //   "Coordinator": null,
    //   "Comments": null,
    //   "CampaignId": null,
    //   "CreatedBy": null,
    //   "deptno": null,
    //   "Prod_code": null,
    //   "Prod_Description": null,
    //   "Prod_Unit": null,
    //   "Prod_Qty": null,
    //   "Prod_Price": null,
    //   "Prod_Amount": null,
    //   "Prod_Comments": null
  };

  const [addProduct, setAddProduct] = useState(false);
  const [openDialogBox, setOpenDialogBox] = useState(false);
  const [messageForUser, setMessageForUser] = useState(null);
  const [productData, setProductData] = useState([]);
  const [productEntries, setProductEntries] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);
  const [currentProductTyping, setCurrentProductTyping] = useState(null);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [errorRow, setErrorRow] = useState(null);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");
  const [organizationList, setOrganizationList] = useState([]);
  const [duplicateItemCodeSnackbar, setDuplicateItemCodeSnackbar] =
    useState(false);
  const [userDepartment, setUserDepartment] = useState(null);

  const defaultRow = {
    id: Date.now(),
    itemCode: "",
    itemDescription: "",
    itemUnit: "",
    itemCurrentStock: "",
    itemQuantity: "",
    itemPrice: "",
    itemAmount: "",
    isSelectedItemCodeCorrect: false,
  };

  useEffect(() => {
    setUserDepartment(currentDepartmentFromLocalStorage);
    const savedProducts = localStorage.getItem("currentEdittingProductsList");
    if (savedProducts) {
      const parsedProducts = JSON.parse(savedProducts);
      if (Array.isArray(parsedProducts) && parsedProducts.length > 0) {
        setProductEntries(parsedProducts); // Restore previous state
      }
    }

    document.addEventListener("keydown", e => {
      if (e.key === "F2") {
        // Suppress default behaviour 
        // e.g. F1 in Microsoft Edge on Windows usually opens Windows help
        e.preventDefault()
      }
    })

    document.addEventListener("keyup", e => {

      console.log("name of input f2 clicked", e.target.name)
      if (e.key === "F2") {
        // Handle the keyup event
        console.log("f2 pressed")
        if (e.target.name == "organization") {
          setF2CustomerSearch(true)
        }
        if (e.target.name == "itemcode") {
          setF2PopupViewToggle(true)
        }


      }
    })

  }, []);

  console.log("userDepartment", userDepartment);

  const handleAddRow = (e) => {
    e.preventDefault();

    const newRow = {
      id: Date.now(),
      itemCode: "",
      itemDescription: "",
      itemImage: "",
      itemUnit: "",
      itemCurrentStock: "",
      itemQuantity: "",
      itemPrice: "",
      itemAmount: "",
      isSelectedItemCodeCorrect: false,
    };

    setProductEntries((prevEntries) => [...prevEntries, newRow]);
  };

  const handleDeleteSelected = (e) => {
    e.preventDefault();
    console.log("productToDelete::", e.target.value);

    const remainingRows = productEntries.filter(
      (entry) => !selectedRows.includes(entry.id)
    );

    // Ensure at least one row exists
    if (remainingRows.length === 0) {
      remainingRows.push({ ...defaultRow, id: Date.now() });
    }

    setProductEntries(remainingRows);
    setSelectedRows([]);
  };

  const handleInputChange = (id, field, value) => {


    console.log("id f v", id, field, value);

    setCurrentProductEntryRowId(id);

    // Set the current value being typed
    setCurrentProductTyping(value);
    if (field === "itemCode") {
      console.log("itemcode is set");
      fetchItemDetails(value, id); // Call your fetch function for item details
    }

    // Update the productEntries state with the new value
    let newArray = productEntries.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [field]: value,
          ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
        };
      }
      return item;
    });

    // Set the updated productEntries array to state
    setProductEntries(newArray);
  };

  const fetchItemDetails = async (itemCode, rowId) => {
    console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
    if (!itemCode) return;

    setTimeout(async () => {
      try {
        const response = await fetch(
          `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/Sitem/${itemCode}`
        );

        console.log("API response status:", response.status); // Log API response status

        const data = await response.json();
        console.log("API response data:", data); // Log response data
        setProductData(data);
      } catch (error) {
        console.error("Error fetching item details:", error);
      }
    }, 500); // Delay API call to avoid excessive requests
  };

  const selectProduct = (setProductCode) => {
    console.log("index of select product", setProductCode);
    setIsSubmittingForm(true);

    const isDuplicate = productEntries.some(
      (product) => product.itemCode === setProductCode
    );
    if (isDuplicate) {
      // alert('this item already exists')
      setDuplicateItemCodeSnackbar(true);
      setIsSubmittingForm(false);
      return;
    }

    const selectedProduct = productData.find(
      (product) => product.Code === setProductCode
    );

    if (selectedProduct) {
      setProductEntries((prevEntries) =>
        prevEntries.map((entry) =>
          entry.id === currentProductEntryRowId
            ? {
              ...entry,
              itemCode: selectedProduct.Code,
              itemDescription: selectedProduct.Description,
              itemImage: selectedProduct.Imagepath,
              // itemUnit: selectedProduct.unit,
              itemUnit: "PCS",
              itemCurrentStock: selectedProduct.Stock, // Adjust according to your product data
              itemPrice: selectedProduct.SelPrice, // Adjust according to your product data
              itemAmount: selectedProduct.SelPrice * entry.itemQuantity, // Example calculation
              isSelectedItemCodeCorrect: true, // Example calculation
            }
            : entry
        )
      );
    }
    setIsDropdownOpen(false);
    setProductData(null);
  };


  const selectCustomerOrganization = (customer) => {

    console.log("customer after select customer", customer.phone?.trim());

    // here call state spread replace oraganisation with selected value use this object tot saveThatLeadFormState
    //customer.Custname

    let salesmanNameToPutInForm = ""

    let salesPersonNameObject = salespersonList?.find((item) => item.EMP_ID?.trim() == customer.sale_man?.trim())
    if (salesPersonNameObject) {
      salesmanNameToPutInForm = customer.sale_man

    } else {

      if (accessgroupFromLocal != "ADMIN" && accessgroupFromLocal != "COORDINATOR") {
        let empIdFromLocal = localStorage.getItem("currentUserEmployeeID")
        if (empIdFromLocal) {
          salesmanNameToPutInForm = empIdFromLocal
        }

      }

    }


    // console.log("salesmanNameToPutInForm array was ", salesPersonNameObject, salespersonList)

    setFormData({
      ...formData,
      account: customer.account?.trim(),
      organization: customer.Custname?.trim(),
      // lead: customer.Custname,
      phone: customer.phone?.trim(),
      salesperson: salesmanNameToPutInForm,
      email:customer.email?.trim(),
      streetAddress:customer.address1?.trim(),
    });
  };



  useEffect(() => {
    if (productEntries.length === 0) {
      // clearProductsList()
      localStorage.removeItem("currentEdittingProductsList");
    }
  }, [productEntries]);

  useEffect(() => {
    console.log("productEntries1", productEntries);

    if (productEntries.length > 0) {
      setAddProduct(true);
    }

    localStorage.setItem(
      "currentEdittingProductsList",
      JSON.stringify(productEntries)
    );
    const itemCodeInProducts = productEntries.map(
      (itemcodeProd) => itemcodeProd.itemCode
    );
    console.log("itemCodeInProducts:", itemCodeInProducts);

    // Check if any item has isSelectedItemCodeCorrect as false
    const hasIncorrectItemCode = productEntries.some(
      (item) => !item.isSelectedItemCodeCorrect
    );

    if (hasIncorrectItemCode) {
      setIsSubmittingForm(false);
    }
  }, [productEntries]);

  const existingFormData = () => {
    const savedData = localStorage.getItem("currentEditingLeadForm");
    return savedData ? JSON.parse(savedData) : initialFormData;
  };

  const [formData, setFormData] = useState(toEditLead || existingFormData());

  useEffect(() => {
    localStorage.setItem("currentEditingLeadForm", JSON.stringify(formData));
    console.log("formData updated:", formData);
  }, [formData]);

  const handleChange = (e) => {

    console.log("handleChange in entry form input value", e.target.value);

    const { name, value, type, files } = e.target;

    if (name === "lead") {
      console.log("value of lead name only", value);
      fetchOrganizationList(value);
    }

    if (name === "organization") {
      console.log("value of organization only", value);
      fetchOrganizationList(value);
    }

    if (type === "file") {
      const file = files?.[0]; // Safely access the first file
      if (file) {
        setFileName(file.name); // Update the state with the file name
      } else {
        setFileName("No file chosen"); // Reset if no file is selected
      }
    } else {
      // Update the form data

      let empIdFromLocal = localStorage.getItem("currentUserEmployeeID")

      setFormData({
        ...formData,
        [name]: name === "territory" ? value.toLowerCase() : value,
        account: name == "organization" ? "00000000" : formData.account,
        [name]: name === "salesperson" ? (accessgroupFromLocal != "ADMIN" && accessgroupFromLocal != "COORDINATOR") ? empIdFromLocal : value
          : value,


      });

      // Update the territory label based on the selected country
      if (name === "country") {
        switch (value) {
          case "unitedArabEmirates":
            setTerritoryLabel("Emirate");
            break;
          case "unitedStates":
            setTerritoryLabel("State");
            break;
          case "unitedKingdom":
            setTerritoryLabel("County");
            break;
          case "india":
            setTerritoryLabel("State");
            break;
          case "canada":
            setTerritoryLabel("Province");
            break;
          case "australia":
            setTerritoryLabel("Region");
            break;
          default:
            setTerritoryLabel("Territory");
        }
      }
    }
  };

  const fetchOrganizationList = async (value) => {

    console.log("fetching organization list >>> ", apiPaths_from_local_storage[0].API_CONFIG)
    // setTimeout(async() => {
    if (!value || value.length < 1) {
      return;
    } else {
      try {
        const response = await axios.get(
          `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Customer/${company_code_from_local_storage}/Cust/${value}/${userDepartment}`
        );
        // console.log("organizationList is fetched success", response.data);
        setOrganizationList(response.data);
      } catch (error) {
        console.log("Error fetching organization details:", error);
      }
    }
  };

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const cancelForm = (e) => {
    console.log("cancel Lead ", e.target.value);
    setFormData(initialFormData);
    clearProductsList();
    clearLeadList();
    setProductEntries([])
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const currentTimestamp = new Date().toISOString(); // Capture edit time

    const updatedLead = {
      // ...selectedLead, // Retain existing lead details
      ...toEditLead, // Retain existing lead details
      ...formData, // Override with new form data
      name: formData.lead ? toTitleCase(formData.lead) : toEditLead?.lead || "",
      organization: formData.organization
        ? toTitleCase(formData.organization)
        : toEditLead?.organization || "",
      title: formData.title
        ? toTitleCase(formData.title)
        : toEditLead?.title || "",
      city: formData.city ? toTitleCase(formData.city) : toEditLead?.city || "",
      lastUpdated: currentTimestamp, // Store last updated time
      timeline: [
        ...(toEditLead?.timeline || []), // Keep existing timeline
        {
          date: currentTimestamp,
          activity: "Lead details updated",
        },
      ],
    };

    console.log("Updated Lead Data:", updatedLead);

    onFormSubmit(updatedLead); // Submit updated data
    // alert("Lead Updated Successfully!");
    setFormData(initialFormData);
  };

  const handleSubmit = (e) => {
    console.log("e", e.target.value);
    e.preventDefault();
    console.log("isSubmittingForm:", isSubmittingForm);

    console.log("productEntries:", productEntries);
    const errorRows = productEntries
      .map((prod, index) =>
        !prod.isSelectedItemCodeCorrect && prod.itemCode.length > 0
          ? index + 1
          : -1
      )
      .filter((index) => index !== -1); // Filter out invalid indices (-1)

    if (errorRows.length > 0) {
      console.log("Incorrect Item Codes found at indices:", errorRows);
      setErrorRow(errorRows);
      setOpenSnackbar(true);
      return;
    } else {
      // setOpenSubmitSnackbar(true); // Show success snackbar
      // setOpenSubmitSnackbar(true); // Show success snackbar
    }

    // if(isSubmitingForm){

    const currentTimestamp = new Date().toISOString(); // Get the current timestamp

    // Apply title case to relevant fields
    const formDataWithTitleCase = {
      ...formData,
      name: formData.lead ? toTitleCase(formData.lead) : "", // Convert name to title case
      organization: formData.organization
        ? toTitleCase(formData.organization)
        : "", // Convert name to title case
      title: formData.title ? toTitleCase(formData.title) : "", // Convert name to title case
      city: formData.city ? toTitleCase(formData.city) : "", // Convert city to title case
      leadEntryTime: currentTimestamp,
      timeline: [
        {
          date: currentTimestamp,
          activity: "Lead created",
        },
      ],
    };

    console.log(
      "Form Data with Lead Entry Time and Title Case:",
      formDataWithTitleCase
    );

    //onFormSubmit(formDataWithTitleCase);
    // setContacts(formDataWithTitleCase);

    callAPIToSaveData(formDataWithTitleCase);


  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setDuplicateItemCodeSnackbar(false);
  };

  const clearLeadList = () => {
    localStorage.removeItem("currentEdittingLeadList");
    setFormData(initialFormData);
  };

  const clearProductsList = () => {
    localStorage.removeItem("currentEdittingProductsList");
    setProductData([]);

  };

  useEffect(() => {
    const savedProducts = localStorage.getItem("currentEdittingProductsList");
    if (savedProducts) {
      const parsedProducts = JSON.parse(savedProducts);
      if (Array.isArray(parsedProducts) && parsedProducts.length > 0) {
        setProductData(parsedProducts); // Restore previous state
      }
    }

    //set salesperson name if accegrp is sales 

    if (accessgroupFromLocal != "ADMIN" && accessgroupFromLocal != "COORDINATOR") {
      let empIdFromLocal = localStorage.getItem("currentUserEmployeeID")
      if (empIdFromLocal) {
        let salesmanNameToPutInForm = empIdFromLocal
        setFormData({
          ...formData,
          salesperson: salesmanNameToPutInForm
        });
      }



    }

  }, []);

  const callAPIToSaveData = (dataForAPI) => {
    console.log("dataForAPI:", dataForAPI);
    console.log("productEntries:", productEntries);

    let arrayWeHaveToGiveToAPI = [];

    if (productEntries.length > 0) {
      arrayWeHaveToGiveToAPI = productEntries.map((product, index) => {
        // {console.log("product.itemAmount:::",product.itemAmount)}
        // {console.log("productItemCode:::",product.itemCode)}
        // {console.log("product.itemCurrentStock:::",product.itemCurrentStock)}
        // {console.log("product.itemDescription:::",product.itemDescription)}
        // {console.log("product.itemImage:::",product.itemImage)}
        // {console.log("product.itemPrice:::",product.itemPrice)}
        // {console.log("product.itemQuantity:::",product.itemQuantity)}
        // {console.log("product.itemUnit:::",product.itemUnit)}
        return {
          CmpCode: company_code_from_local_storage,
          mode: formData.isEditinglead ? "EDIT" : "ENTRY",
          lead_id: dataForAPI.id + "",
          lead_entryTime: format(new Date(), "yyyy-MM-dd"),
          lead_creatorid: currentUserEMPID?.trim(),
          lead_coordinator: (accessgroupFromLocal == "COORDINATOR" || accessgroupFromLocal == "ADMIN") ? currentUserEMPID?.trim() : "-",
          lead_salesperson: dataForAPI.salesperson?.trim(), //
          lead_teamid: "0",
          lead_CampaignId: dataForAPI.campaignId,
          lead_account: dataForAPI.account,
          lead_organization: dataForAPI.organization,
          lead_notes: dataForAPI.notes,
          lead_country: dataForAPI.country,
          lead_city: dataForAPI.city,
          lead_territory: dataForAPI.territory,
          lead_area: dataForAPI.area,
          lead_streetaddress: dataForAPI.streetAddress,
          lead_location: dataForAPI.location,
          lead_appartment: dataForAPI.apartment,
          lead_primarycontact: dataForAPI.name,
          lead_primarycontacttitle: dataForAPI.title,
          lead_phone: dataForAPI.phone,
          lead_isphonewhatsapp: dataForAPI.isPhoneWhatsApp,
          lead_alt_phone: dataForAPI.alternatePhone, //
          lead_alt_isphonewhatsapp: dataForAPI.isAlternatePhoneWhatsApp, //
          lead_email: dataForAPI.email, //
          lead_stage: "", //
          lead_probability: dataForAPI.probability, //
          // lead_probability: Number(dataForAPI.probability), //
          lead_priority: dataForAPI.priority,
          // lead_priority: getPriorityName(dataForAPI.priority),
          lead_priority: dataForAPI.priority, //
          lead_source: dataForAPI.leadSource, //
          lead_status: dataForAPI.status, //
          lead_assignedto: dataForAPI.assignTo, //
          lead_bookedamount: Number(dataForAPI.bookedAmount), //
          lead_currencycode: dataForAPI.currency, //
          lead_currencyrate: "1", //
          deptno: currentDepartmentFromLocalStorage, //
          prod_code: product.itemCode, //
          prod_Description: product.itemDescription, //
          prod_Unit: product.itemUnit || "0", //
          // prod_Qty: Number(product.itemQuantity) || 0, //
          prod_Qty: product.itemQuantity || "0", //
          // prod_Price: Number(product.itemPrice) || 0, //
          prod_Price: product.itemPrice || 0, //
          // prod_Amount:
          //   (Number(product.itemQuantity) || 0) *
          //   (Number(product.itemPrice) || 0), //
          prod_Amount: 0, //
          prod_Comments: "", //
          prod_imagepath: "", //
        };
      });
    } else {
      arrayWeHaveToGiveToAPI = [
        {
          CmpCode: company_code_from_local_storage,
          mode: formData.isEditinglead ? "EDIT" : "ENTRY",
          lead_id: dataForAPI.id + "",
          lead_entryTime: format(new Date(), "yyyy-MM-dd"),
          lead_creatorid: currentUserEMPID?.trim(),
          lead_coordinator: currentUserEMPID?.trim(),
          lead_salesperson: dataForAPI.salesperson?.trim(),
          lead_teamid: "0",
          lead_CampaignId: dataForAPI.campaignId,
          lead_account: dataForAPI.account,
          lead_organization: dataForAPI.organization,
          lead_notes: dataForAPI.notes,
          lead_country: dataForAPI.country,
          lead_city: dataForAPI.city,
          lead_territory: dataForAPI.territory,
          lead_area: dataForAPI.area,
          lead_streetaddress: dataForAPI.streetAddress,
          lead_location: dataForAPI.location,
          lead_appartment: dataForAPI.apartment,
          lead_primarycontact: dataForAPI.name,
          lead_primarycontacttitle: dataForAPI.title,
          lead_phone: dataForAPI.phone,
          lead_isphonewhatsapp: dataForAPI.isPhoneWhatsApp,
          lead_alt_phone: dataForAPI.alternatePhone,
          lead_alt_isphonewhatsapp: dataForAPI.isAlternatePhoneWhatsApp,
          lead_email: dataForAPI.email,
          lead_stage: "",
          lead_probability: dataForAPI.probability,
          // lead_probability: Number(dataForAPI.probability),
          lead_priority: dataForAPI.priority,
          // lead_priority: getPriorityName(dataForAPI.priority),
          lead_priority: dataForAPI.priority,
          lead_source: dataForAPI.leadSource,
          lead_status: dataForAPI.status,
          lead_assignedto: dataForAPI.assignTo,
          lead_bookedamount: Number(dataForAPI.bookedAmount),
          lead_currencycode: dataForAPI.currency,
          lead_currencyrate: "1",
          deptno: currentDepartmentFromLocalStorage,
          prod_code: "",
          prod_Description: "",
          prod_Unit: "",
          prod_Qty: "0",
          prod_Price: "0",
          prod_Amount: 0,
          prod_Comments: "",
          prod_imagepath: "",
        },
      ];
    }
    const jsonToSend = JSON.stringify(arrayWeHaveToGiveToAPI);
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRM_LeadRegister`;

    console.log("json to send to LEAD REGISTER", jsonToSend);

    axios
      .post(apiUrl, jsonToSend, {
        headers: {
          // Overwrite Axios's automatically set Content-Type
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("res is ", dataForAPI);
        setOpenSubmitSnackbar(true); // Show success snackbar

        setOpenDialogBox(true);

        if (res.data.result == "Saved") {
          setMessageForUser({
            result: "success",
            title: "Success",
            message: "Successfully Saved",
          });
          console.log("success");

          clearProductsList();
          clearLeadList();

          setAddProduct(false);
          setProductEntries([]);

        } else {
          setMessageForUser({
            result: "failure",
            title: "Error",
            message: "Could not save, something went wrong",
          });
          console.log("failure");
        }
      })
      .catch((err) => {
        console.log("error while posting lead", err);
      });
  };

  const productEntryInAllEntries = (productEntryTimeline) => {
    console.log("productEntryTimeline from all entries:", productEntryTimeline);

    // Ensure productEntryTimeline has data and extract the first entry
    const productFormData =
      productEntryTimeline && productEntryTimeline[0]
        ? productEntryTimeline[0]
        : {};

    console.log("productFormData:", productFormData);

    const isProductAdded = !!(
      productFormData.itemCode ||
      productFormData.itemDescription ||
      productFormData.itemUnit ||
      productFormData.itemCurrentStock ||
      productFormData.itemQuantity ||
      productFormData.itemPrice ||
      productFormData.itemAmount
    );

    console.log("isProductAdded ::  :", isProductAdded);

    setFormData((prevFormData) => ({
      ...prevFormData,
      isItemAdded: isProductAdded,
      itemCode: productFormData.itemCode || "",
      itemDescription: productFormData.itemDescription || "",
      itemUnit: productFormData.itemUnit || "",
      itemCurrentStock: productFormData.itemCurrentStock || "",
      itemQuantity: productFormData.itemQuantity || "",
      itemPrice: productFormData.itemPrice || "",
      itemAmount: productFormData.itemAmount || "",
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handlePriorityClick = (level) => {
    console.log("level handlePriorityClick:", level);
    setFormData({ ...formData, priority: level });
  };

  useEffect(() => {
    const savedProducts = localStorage.getItem("currentEdittingProductsList");
    if (savedProducts && JSON.parse(savedProducts).length > 0) {
      setAddProduct(true);
      // setProductEntries(JSON.parse(savedProducts)); // Restore previous state
    }
  }, []);

  const onAddProduct = () => {
    setAddProduct(true);
  };

  const [territoryLabel, setTerritoryLabel] = useState("Territory");

  const nameRegex = /^[A-Za-z\s]{2,50}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // const [showOrganizationListDropdown, setShowOrganizationListDropdown] = useState(false);
  const [showNameListDropdown, setShowNameListDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownListRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
      // setShowNameListDropdown(false);
    }
  };

  const handleListClickOutside = (event) => {
    if (
      dropdownListRef.current &&
      !dropdownListRef.current.contains(event.target)
    ) {
      // setShowDropdown(false);
      setShowNameListDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleListClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleListClickOutside);
    };
  }, []);

  const callCordinatorListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/COORDINATORLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setCoordinatorList([
          { EMP_ID: "GENERAL", NAME: "GENERAL" },
          ...res.data,
        ]);
      })
      .catch((err) => { });
  };

  const callSalesPersonListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    callCordinatorListAPI();
    callSalesPersonListAPI();
  }, []);

  return (
    <div className="flex  justify-center items-center  mobile-only-lead-entry-form">
      <form className="bg-white rounded-lg px-4 pt-2 w-full  shadow">
        <div className="flex   justify-between items-center">
          <div></div>
          <button
            onClick={(e) => cancelForm(e)}
            className="text-gray-700 bg-gray-200 hover:bg-gray-300 px-4 py-2 my-2 rounded w-40 transition"
          >
            Clear All Data
          </button>
        </div>
        <div className="allEntriesDivHeading flex justify-between items-center ">
          <h2 className="text-2xl font-normal text-center my-2 text-gray-600">
            {formData.isEditinglead ? "Edit Lead" : "Lead Entry Form"}

          </h2>



          {
            <span> Customer Account : {formData.account}</span>
          }


        </div>

        {console.log("productEntries in allEntriesForm", productEntries)}

        {
          productEntries != undefined &&
            productEntries?.some(
              (prod) => !prod.isSelectedItemCodeCorrect && prod.itemCode.length > 0
            ) ? (
            <Snackbar
              open={openSnackbar}
              autoHideDuration={3000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert
                onClose={handleCloseSnackbar}
                severity="error"
                sx={{ width: "100%" }}
              >
                {`Item Code is not Correct at row ${errorRow} `}
              </MuiAlert>
            </Snackbar>
          ) : (
            <Snackbar
              open={openSubmitSnackbar}
              autoHideDuration={3000}
              onClose={handleCloseSubmitSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert
                onClose={handleCloseSnackbar}
                severity="success"
                sx={{ width: "100%" }}
              >
                Form Submitted Successfully!
              </MuiAlert>
            </Snackbar>
          )
        }

        {
          duplicateItemCodeSnackbar && (
            <Snackbar
              open={duplicateItemCodeSnackbar}
              autoHideDuration={3000}
              onClose={handleCloseSubmitSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert
                onClose={handleCloseSnackbar}
                severity="error"
                sx={{ width: "100%" }}
              >
                This item is already selected. Duplicate entries are not allowed!
              </MuiAlert>
            </Snackbar>
          )
        }

        <div className="leadFormDivAllEntries grid grid-cols-4 gap-4">
          <div className="mb-0 relative" ref={dropdownRef}>
            <TextField
              label="Customer / Organization"
              name="organization"
              required
              value={formData.organization}
              onChange={(e) => {
                handleChange(e);
                setShowDropdown(true); // Show dropdown when typing
              }}
              // placeholder="Enter lead Organization"
              placeholder="Enter Customer Organization"
              fullWidth
              variant="standard"
              id="standard"
              autoComplete="off"
              color="red-500"
              error={!formData.organization}
              // error={
              //   formData.organization && !nameRegex.test(formData.organization)
              // }
              // helperText={
              //   formData.organization && !nameRegex.test(formData.organization)
              //     ? "Organization Name must contain 2-50 characters long"
              //     : ""
              // }
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />

            {organizationList &&
              showDropdown &&
              formData.organization?.length > 0 && (
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                  {console.log("organizationList:", organizationList)}
                  {organizationList
                    // ?.filter((product) => product.Code) // Filter matching products
                    .map((organization, index) => (
                      <div
                        onClick={() => {
                          selectCustomerOrganization(organization);
                          setShowDropdown(false);
                        }}
                        key={index}
                        className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                      >
                        <p className="font-normal">{organization.Custname}</p>
                        {/* <p className="text-xs text-gray-500">
                                {product.Description}
                              </p>
                              <p className="text-xs text-gray-500">
                                {product.Imagepath}
                              </p> */}
                      </div>
                    ))}
                </div>
              )}
          </div>

          <div className="mb-0 ">
            <TextField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter lead Email"
              fullWidth
              required
              variant="standard"
              id="standard"
              error={!formData.email || !emailRegex.test(formData.email)}
              helperText={
                formData.email && !emailRegex.test(formData.email)
                  ? "Enter a valid email address (e.g., example@domain.com)"
                  : ""
              }
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="flex justify-between items-center ">
            <div className="mb-0 w-[85%]">
              <TextField
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter lead Phone Number"
                fullWidth
                required
                variant="standard"
                id="standard"
                error={!formData.phone}
                // error={formData.phone && !/^\d{10}$/.test(formData.phone)} // Only 10 digits allowed
                // helperText={
                //   formData.phone && !/^\d{10}$/.test(formData.phone)
                //     ? "Phone number must be 10 digits"
                //     : ""
                // }
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important", // Removes any shadow applied
                  },
                  width: "100%",
                }}
              />
            </div>
            <div>
              <div className="flex justify-center items-center gap-2">
                <img
                  src={whatsapp}
                  alt="whatsapp-icon"
                  className="w-5 h-5 object-contain"
                />
                <input
                  type="checkbox"
                  className="rounded border border-sm shadow cursor-pointer"
                  name="isPhoneWhatsApp"
                  checked={formData.isPhoneWhatsApp}
                  onChange={handleCheckboxChange}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div className="mb-0 w-[85%]">
              <TextField
                label="Alternate Phone"
                name="alternatePhone"
                type="number"
                value={formData.alternatePhone}
                onChange={handleChange}
                placeholder="Enter Alt Phone Number"
                fullWidth
                variant="standard"
                id="standard"
                // error={formData.alternatePhone && !/^\d{10}$/.test(formData.alternatePhone)} // Only 10 digits allowed
                // helperText={
                //   formData.alternatePhone && !/^\d{10}$/.test(formData.alternatePhone)
                //     ? "Phone number must be 10 digits"
                //     : ""
                // }
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important", // Removes any shadow applied
                  },
                  width: "100%",
                }}
              />
            </div>

            <div className="flex justify-center items-center gap-2">
              <img
                src={whatsapp}
                alt="whatsapp-icon"
                className="w-5 h-5 object-contain"
              />
              <input
                type="checkbox"
                className="rounded border border-sm shadow cursor-pointer"
                name="isAlternatePhoneWhatsApp"
                checked={formData.isAlternatePhoneWhatsApp}
                onChange={handleCheckboxChange}
              />
            </div>
          </div>

          <div className="mb-0 relative" ref={dropdownListRef}>
            <TextField
              label="Contact Person"
              name="lead"
              // value={formData.name}
              value={formData.lead}
              // onChange={handleChange}

              onChange={(e) => {
                handleChange(e);
                setShowNameListDropdown(true); // Show dropdown when typing
              }}
              placeholder="Enter Contact Name"
              fullWidth
              required
              variant="standard"
              id="standard"
              error={!formData.lead}
              // error={formData.lead && !nameRegex.test(formData.lead)}
              // helperText={
              //   formData.lead && !nameRegex.test(formData.lead)
              //     ? "Name must contain only letters and be 2-50 characters long"
              //     : ""
              // }
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
            {/* {organizationList &&
              showNameListDropdown &&
              formData.organization?.length > 0 && (
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                  // {/* {console.log("organizationList:", organizationList)} 
                  {organizationList
                    // ?.filter((product) => product.Code) // Filter matching products
                    .map((organization, index) => (
                      <div
                        onClick={() => {
                          selectCustomerName(organization);
                          setShowNameListDropdown(false);
                        }}
                        key={index}
                        className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                      >
                        <p className="font-normal">{organization.Custname}</p>
                        {/* <p className="text-xs text-gray-500">
                                {product.Description}
                              </p>
                              <p className="text-xs text-gray-500">
                                {product.Imagepath}
                              </p> 
                      </div>
                    ))}
                </div>
              )} */}
          </div>

          <div className="mb-0">
            <TextField
              select
              label="Status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              fullWidth
              required
              variant="standard"
              id="standard"
              error={!formData.status}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              {/* <MenuItem value="" disabled>
                Select Status
              </MenuItem> */}
              <MenuItem value="newLead">
                <button className="w-full bg-orange-400 text-white px-4 py-0 rounded">
                  New Lead
                </button>
              </MenuItem>

              <MenuItem value="contacted">
                <button className="w-full bg-blue-600 text-white px-4 py-0 rounded">
                  Contacted
                </button>
              </MenuItem>

              <MenuItem value="attemptedToContact">
                <button className="w-full bg-red-400 text-white px-4 py-0 rounded">
                  Attempted to Contact
                </button>
              </MenuItem>

              <MenuItem value="qualified">
                <button className="w-full bg-green-400 text-white px-4 py-0 rounded">
                  Qualified
                </button>
              </MenuItem>

              <MenuItem value="unQualified">
                <button className="w-full bg-red-600 text-white px-4 py-0 rounded">
                  Unqualified
                </button>
              </MenuItem>
            </TextField>
          </div>

          <div className="mb-0">
            <TextField
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter lead Title"
              fullWidth
              variant="standard"
              id="standard"

              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="Lead Notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Enter lead Notes"
              fullWidth
              variant="standard"
              id="standard"

              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              select
              label="Lead Source"
              name="leadSource"
              value={formData.leadSource}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Status
              </MenuItem>
              <MenuItem value="walkin">Walk-in</MenuItem>
              <MenuItem value="phone">Phone</MenuItem>
              <MenuItem value="whatsapp">Whatsapp</MenuItem>
              <MenuItem value="email">E-mail</MenuItem>
              <MenuItem value="online">Online</MenuItem>
              <MenuItem value="otherSource">Others</MenuItem>
            </TextField>
          </div>

          <div className="mb-0">
            {/* <TextField
              select
              label="Coordinator"
              name="coordinator"
              value={formData.coordinator}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Coordinator
              </MenuItem>

              {coordinatorList?.map((item) => {
                return <MenuItem value={item.EMP_ID}>{item.NAME}</MenuItem>;
              })}
            </TextField> */}
            <p>Coordinator</p>
            <h4>{(accessgroupFromLocal == "COORDINATOR" || accessgroupFromLocal == "ADMIN") ? userName : "GENERAL"}</h4>
          </div>

          <div className="mb-0">
            <TextField
              disabled={accessgroupFromLocal != "ADMIN" && accessgroupFromLocal != "COORDINATOR"}
              select
              label="Sales Person"
              name="salesperson"
              value={formData.salesperson}
              onChange={handleChange}
              fullWidth
              required
              variant="standard"
              id="standard"
              error={!formData.salesperson}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Sales Person
              </MenuItem>

              {salespersonList?.map((item) => {
                return <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>;
              })}
            </TextField>
          </div>

          <div className="mb-0">

            <TextField
              label="Project/Campaign"
              name="campaignId"
              // value={formData.name}
              value={formData.campaignId}
              onChange={handleChange}
              placeholder="Project or Campaign"
              fullWidth
              required
              variant="standard"
              id="standard"
              error={!formData.campaignId}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />

          </div>

          <div className="mb-0">
            <TextField
              select
              key={formData.departmentNo}
              label="Department No"
              name="departmentNo"
              value={formData.departmentNo}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Department
              </MenuItem>
              <MenuItem value="dept101">Sales</MenuItem>
              <MenuItem value="dept102">Marketing</MenuItem>
              <MenuItem value="dept103">Customer Support</MenuItem>
              <MenuItem value="dept104">IT</MenuItem>
              <MenuItem value="dept105">Finance</MenuItem>
              <MenuItem value="dept106">HR</MenuItem>
              <MenuItem value="dept107">Logistics</MenuItem>
              <MenuItem value="dept108">R&D</MenuItem>
            </TextField>
          </div>

          {/* <div className="mb-0">
            <TextField
              label="Lead Probability (%)"
              name="probability"
              type="number"
              value={formData.probability || ""}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="leadProbability"
              InputProps={{
                inputProps: { min: 0, max: 100 }, // Restricts input to between 0 and 100
              }}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Apply Figtree font for the label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div> */}

          <div className="mb-0">
            <FormControl fullWidth variant="standard">
              <InputLabel id="leadProbability-label">
                Lead Probability (%)
              </InputLabel>
              <Select
                labelId="leadProbability-label"
                id="leadProbability"
                name="probability"
                value={formData.probability || ""}
                onChange={handleChange}
              >
                {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="mb-4 flex items-center space-x-4">
            {/* Currency Selector */}
            <TextField
              select
              label="Currency"
              name="currency"
              value={formData.currency || ""} // Separate state for currency
              onChange={handleChange}
              variant="standard"
              sx={{
                width: "100px",
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                  fontSize: "13px",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="AED">AED</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
              <MenuItem value="GBP">GBP</MenuItem>
              <MenuItem value="INR">INR</MenuItem>
              <MenuItem value="JPY">JPY</MenuItem>
              <MenuItem value="AUD">AUD</MenuItem>
            </TextField>

            {/* Booked Amount */}
            <TextField
              label="Booked Amount"
              name="bookedAmount"
              type="number"
              value={formData.bookedAmount || ""} // Separate state for booked amount
              onChange={handleChange}
              fullWidth
              variant="standard"
              InputProps={{
                inputProps: { min: 0 }, // Prevent negative amounts
              }}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          {/* Country Field */}
          <div className="mb-0">
            <TextField
              select
              label="Country"
              name="country"
              value={formData.country || ""}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="country"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="unitedArabEmirates">
                United Arab Emirates
              </MenuItem>
              <MenuItem value="unitedStates">United States</MenuItem>
              <MenuItem value="unitedKingdom">United Kingdom</MenuItem>
              <MenuItem value="india">India</MenuItem>
              <MenuItem value="canada">Canada</MenuItem>
              <MenuItem value="australia">Australia</MenuItem>
              <MenuItem value="OtherCurrency">Others</MenuItem>
            </TextField>
          </div>

          {/* Territory Field */}
          <div className="mb-0">
            <TextField
              select
              label={territoryLabel} // Dynamically updated label
              name="territory"
              value={formData.territory}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="territory"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            >
              <MenuItem value="" disabled>
                Select {territoryLabel}
              </MenuItem>
              <MenuItem value="dubai">Dubai</MenuItem>
              <MenuItem value="abudhabi">Abu Dhabi</MenuItem>
              <MenuItem value="sharjah">Sharjah</MenuItem>
              <MenuItem value="ajman">Ajman</MenuItem>
              <MenuItem value="otherTerritory">Others</MenuItem>
            </TextField>
          </div>

          {/* Street Address Field */}
          <div className="mb-0">
            <TextField
              label="Street Address"
              name="streetAddress"
              value={formData.streetAddress || ""}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="streetAddress"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          {/* City Field */}
          <div className="mb-0">
            <TextField
              label="City"
              name="city"
              value={formData.city || ""}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="city"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          {/* Apartment Field */}
          <div className="mb-0">
            <TextField
              label="Apartment (Optional)"
              name="apartment"
              value={formData.apartment || ""}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="apartment"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          {/* Area Name */}
          <div className="mb-0">
            <TextField
              label="Area Name"
              name="area"
              type="text"
              value={formData.area}
              onChange={handleChange}
              placeholder="Enter lead Area name"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="Location"
              name="location"
              type="text"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter lead Location"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important", // Removes any shadow applied
                },
              }}
            />
          </div>

          {/* Priority Selection */}
          <div className=" flex gap-4 items-center justify-left mt-4 ">
            <label className="block font-normal text-base text-black text-opacity-60">
              Priority
            </label>
            <div className="flex space-x-2">
              {[1, 2, 3].map((level, index) => (
                <button
                  key={`${level}-${index}`}
                  type="button"
                  className={`text-2xl transition-all duration-300 ease-in-out ${formData.priority >= level
                    ? "text-yellow-500 transform scale-110"
                    : "text-gray-400 transform scale-100"
                    } hover:scale-125 hover:text-yellow-500`}
                  onClick={() => handlePriorityClick(level)}
                >
                  ★
                </button>
              ))}
            </div>
          </div>

          <div></div>
          <div className=" flex gap-4 items-center justify-end mt-4 ">
            <div>
              <button
                type="button"
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                onClick={onAddProduct}
              >
                Add Product
              </button>
            </div>
          </div>
        </div>
        {
          addProduct && (
            <ProductsInfo
              lead={formData.lead}
              productEntryInAllEntries={productEntryInAllEntries}
              onAddProducts={addProduct}
              clearProductsList={clearProductsList}
              productEntries={productEntries}
              setProductEntries={setProductEntries}
              handleAddRow={handleAddRow}
              handleDeleteSelected={handleDeleteSelected}
              handleInputChange={handleInputChange}
              selectProduct={selectProduct}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              currentProductEntryRowId={currentProductEntryRowId}
              productData={productData}
              setCurrentF2ItemForSearchPopup={setCurrentF2ItemForSearchPopup}
            />
          )
        }

        <div className="flex justify-center pt-3 pb-0  gap-4 ">
          <button
            type="submit"
            className={`text-white px-4 py-2 my-2 rounded w-40 ${formData.organization &&
              formData.lead &&
              formData.email && emailRegex.test(formData.email) &&
              formData.phone &&
              formData.salesperson &&
              formData.status
              ? "bg-blue-500 hover:bg-blue-700"
              : "bg-gray-400 hover:bg-gray-500 cursor-not-allowed"
              }`}
            onClick={(e) => handleSubmit(e)}
            disabled={
              !formData.organization ||
              !formData.lead ||
              !formData.email || !emailRegex.test(formData.email) ||
              !formData.status ||
              !formData.salesperson ||
              !formData.phone
            }
          >
            Submit
          </button>


        </div>
      </form >


      {
        f2PopupViewToggle && currentF2ItemForSearchPopup &&
        <ItemSearchPopup
          lead={formData.lead}
          productEntryInAllEntries={productEntryInAllEntries}
          onAddProducts={addProduct}
          clearProductsList={clearProductsList}
          productEntries={productEntries}
          setProductEntries={setProductEntries}
          handleAddRow={handleAddRow}
          handleDeleteSelected={handleDeleteSelected}
          handleInputChange={handleInputChange}
          selectProduct={selectProduct}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          currentProductEntryRowId={currentProductEntryRowId}
          productData={productData}
          setF2PopupViewToggle={setF2PopupViewToggle}
          currentF2ItemForSearchPopup={currentF2ItemForSearchPopup}
          setDuplicateItemCodeSnackbar={setDuplicateItemCodeSnackbar}
        />

      }

      {
        f2CustomerSearch &&
        <CustomerSearchF2Popup userDepartment={userDepartment} selectCustomerOrganization={selectCustomerOrganization} setF2CustomerSearch={setF2CustomerSearch} />
      }
    </div >
  );
};

export default AllEntriesForm;
